// extracted by mini-css-extract-plugin
export default {"price":"B5-z","onSale":"C5-z","msrpLabelPrice":"D5-z","msrpLabel":"E5-z","originalPrice":"F5-z","percentOff":"G5-z"};